import { orderApi } from '../api/orderApi'
import type { VendorMetric } from '../api/orderApi'

// SV2 거래처 지표 조회 — C-3 후보(VendorPicker)와 H-5 주거래처 옵션이 같은 키를 공유한다.
// 지표는 보조 정보라 조회 실패 시 호출 화면이 그 줄만 생략한다(오류 화면 금지). 자동 재시도 없음.

export const VENDOR_METRICS_KEY = 'vendor-metrics'

export function vendorMetricsQueryOptions(compId: number | null | undefined) {
  return {
    queryKey: [VENDOR_METRICS_KEY, compId],
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<VendorMetric[]> => orderApi.getVendorMetrics(signal),
    staleTime: 60_000,
    retry: false,
  }
}

export function indexVendorMetrics(list: VendorMetric[] | undefined | null): Map<number, VendorMetric> {
  return new Map((list ?? []).map(m => [m.vendorId, m] as const))
}
